<ion-item lines="none" *ngIf="option && option.choices && selectedLang">
  <ion-select
    #choiceSelect
    class="ion-text-wrap"
    interface="alert"
    [interfaceOptions]="interfaceOptions"
    [placeholder]="'select' | translate"
    [okText]="'select' | translate"
    [cancelText]="'cancel' | translate"
    [disabled]="finalPriceLoading"
    [(ngModel)]="selectedChoiceTimestamp"
    (ionChange)="onSelectionChange($event)"
  >
    <ion-select-option *ngIf="!option.isRequired" [value]="null"
      >—</ion-select-option
    >
    <ion-select-option
      *ngFor="let choice of option.choices; trackBy: trackTimestamp"
      [value]="choice.timestamp"
      [disabled]="choice.outOfPeriod"
    >
      {{ choice.displayLabel }}
    </ion-select-option>
  </ion-select>
</ion-item>
